<template>
  <van-tabbar v-if="show" v-model="activeTab" active-color="#667eea" placeholder>
    <van-tabbar-item v-if="!isTeach" to="/home">
      <template #icon="{ active }">
        <img :src="active ? homeActiveIcon : homeIcon" class="tab-icon" />
      </template>
      首页
    </van-tabbar-item>
    <van-tabbar-item to="/orders">
      <template #icon="{ active }">
        <img :src="active ? orderActiveIcon : orderIcon" class="tab-icon" />
      </template>
      订单
    </van-tabbar-item>
    <van-tabbar-item to="/profile">
      <template #icon="{ active }">
        <img :src="active ? myActiveIcon : myIcon" class="tab-icon" />
      </template>
      我的
    </van-tabbar-item>
  </van-tabbar>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import homeIcon from '@/assets/icons/首页.png';
import homeActiveIcon from '@/assets/icons/首页生效.png';
import orderIcon from '@/assets/icons/订单.png';
import orderActiveIcon from '@/assets/icons/订单生效.png';
import myIcon from '@/assets/icons/我的.png';
import myActiveIcon from '@/assets/icons/我的生效.png';
import { routeWhiteList } from '@/config/routes';

const route = useRoute();
// 是否是助教端
const isTeach = import.meta.env.VITE_APP_MODE === 'teach';
// 根据是否是助教端来决定tab路由
const tabRoutes = isTeach ? ['/orders', '/profile'] : ['/home', '/orders', '/profile'];

const activeTab = computed(() => {
  const idx = tabRoutes.findIndex((path) => route.path.startsWith(path));
  return idx === -1 ? 0 : idx;
});
const show = computed(() => typeof route.name === 'string' && routeWhiteList.includes(route.name));
</script>

<style scoped>
.tab-icon {
  width: 24px;
  height: 24px;
}
.van-tabbar__placeholder {
  background-color: #faf9fe;
}
</style>
